// Specific/clashing lengths should be noted in order of priority.

const storyCategories = (wordCount = "x") => [
  {
    name: "dribble",
    match: 50,
  },
  {
    name: "drabble",
    match: 100,
  },
  {
    name: "twitterature",
    maxChar: 280,
  },
  {
    name: wordCount + "-word story",
    min: 0,
    max: 99,
  },
  {
    name: "microfiction",
    min: 100,
    max: 499,
  },
  {
    name: "sudden fiction",
    min: 500,
    max: 999,
  },
  {
    name: "flash fiction",
    min: 1000,
    max: 3999,
  },
  {
    name: "short story",
    min: 4000,
    max: 7499,
  },
  {
    name: "novelette",
    min: 7500,
    max: 17499,
  },
  {
    name: "novella",
    min: 17500,
    max: 39999,
  },
  {
    name: "novel",
    min: 40000,
    max: 99999,
  },
  {
    name: "epic",
    min: 100000,
  },
];

module.exports = storyCategories;
